import { createSlice } from '@reduxjs/toolkit';
import endPoints from '../api/endpoint';
import store from './store';
import { getApiCall } from '../api/methods';

import { SpendingState } from '../types';

import { setCommonDataLoader } from './commonSlice';

const initialState: SpendingState = {
  spendingData: {},
  departmentSpendingData: {},
  spendingOverAllGraphData: {},
  departmentOverAllGraphData: {},
  departmentSpendings: {},
  setSpendings: {},
  locationSpendings: {},
  categorySpendings: {},
  vendorSpendings: {},
  orderSpendings: {},
  departmentList: {},
  setList: {},
  locationList: {},
  categoryList: {},
  spendingLoading: false,
  episodeSpendings: {},
  overALlGraphLoading: false,
  entitySpendingLoading: false,
  departmentLoading: false,
  setLoading: false,
  locationLoading: false,
  categoryLoding: false,
  vendorLoading: false,
  episodeLoading: false,
  graphAllData: {},
  financeWorksheet: {},
  financeWorksheetLoading: false,
  financeWorksheetGroupBy: 'DATE',
  financeWorksheetProductId: '',
  financeWorksheetQuickSelect: 'ALL_SHIFT',
  financeAddOnCharges: {},
  financeAddOnChargesLoading: false,
  financeWorksheetItemNickName: '',
};
const spendingSlice = createSlice({
  name: 'spending',
  initialState,
  reducers: {
    setSpendingData: (state, action) => {
      const { payload }: any = action;
      state.spendingData = payload;
    },
    setDepartmentSpendingData: (state, action) => {
      const { payload }: any = action;
      state.departmentSpendingData = payload;
    },
    setStudioSpendingGraph: (state, action) => {
      const { payload }: any = action;
      state.spendingOverAllGraphData = payload;
    },
    setDepartmentSpendingGraph: (state, action) => {
      const { payload }: any = action;
      state.departmentOverAllGraphData = payload;
    },
    setDepartmentSpendings: (state, action) => {
      const { payload }: any = action;
      state.departmentSpendings = payload;
    },
    setEpisodeSpendings: (state, action) => {
      const { payload }: any = action;
      state.episodeSpendings = payload;
    },
    setSetSpendings: (state, action) => {
      const { payload }: any = action;
      state.setSpendings = payload;
    },
    setLocationSpendings: (state, action) => {
      const { payload }: any = action;
      state.locationSpendings = payload;
    },
    setCategorySpendings: (state, action) => {
      const { payload }: any = action;
      state.categorySpendings = payload;
    },
    setVendorSpendings: (state, action) => {
      const { payload }: any = action;
      state.vendorSpendings = payload;
    },
    setOrderSpendings: (state, action) => {
      const { payload }: any = action;
      state.orderSpendings = payload;
    },
    setDepartmentList: (state, action) => {
      const { payload }: any = action;
      state.departmentList = payload;
    },
    setSetList: (state, action) => {
      const { payload }: any = action;
      state.setList = payload;
    },
    setLocationList: (state, action) => {
      const { payload }: any = action;
      state.locationList = payload;
    },
    setCategoryList: (state, action) => {
      const { payload }: any = action;
      state.categoryList = payload;
    },
    setLoading: (state, action) => {
      const { payload }: any = action;
      state.spendingLoading = payload;
    },
    setOverAllGraphLoadingLoading: (state, action) => {
      const { payload }: any = action;
      state.overALlGraphLoading = payload;
    },
    setEntitySpendingLoading: (state, action) => {
      const { payload }: any = action;
      state.entitySpendingLoading = payload;
    },
    setDeparetmentLoading: (state, action) => {
      const { payload }: any = action;
      state.departmentLoading = payload;
    },
    setLocationLoading: (state, action) => {
      const { payload }: any = action;
      state.locationLoading = payload;
    },
    setSetLoading: (state, action) => {
      const { payload }: any = action;
      state.setLoading = payload;
    },
    setCategoryLoading: (state, action) => {
      const { payload }: any = action;
      state.categoryLoding = payload;
    },
    setVendorLoading: (state, action) => {
      const { payload }: any = action;
      state.vendorLoading = payload;
    },
    setEpisodeLoading: (state, action) => {
      const { payload }: any = action;
      state.episodeLoading = payload;
    },
    setGraphAllData: (state, action) => {
      const { payload }: any = action;
      state.graphAllData = payload;
    },
    setFinanceWorksheet: (state, action) => {
      const { payload }: any = action;
      state.financeWorksheet = payload;
    },
    setFinanceWorksheetLoading: (state, action) => {
      const { payload }: any = action;
      state.financeWorksheetLoading = payload;
    },
    setFinanceWorksheetGroupBy: (state, action) => {
      const { payload }: any = action;
      state.financeWorksheetGroupBy = payload;
    },
    setFinanceWorksheetProductId: (state, action) => {
      const { payload }: any = action;
      state.financeWorksheetProductId = payload;
    },
    setFinanceWorksheetQuickSelect: (state, action) => {
      const { payload }: any = action;
      state.financeWorksheetQuickSelect = payload;
    },
    setFinanceAddOnCharges: (state, action) => {
      const { payload }: any = action;
      state.financeAddOnCharges = payload;
    },
    setFinanceAddOnChargesLoading: (state, action) => {
      const { payload }: any = action;
      state.financeAddOnChargesLoading = payload;
    },

    setFinanceWorksheetItemNickName: (state, action) => {
      const { payload }: any = action;
      state.financeWorksheetItemNickName = payload;
    },
  },
});

export const {
  setSpendingData,
  setStudioSpendingGraph,
  setDepartmentSpendings,
  setSetSpendings,
  setLocationSpendings,
  setCategorySpendings,
  setVendorSpendings,
  setOrderSpendings,
  setDepartmentList,
  setSetList,
  setLocationList,
  setCategoryList,
  setLoading,
  setEpisodeSpendings,
  setOverAllGraphLoadingLoading,
  setEntitySpendingLoading,
  setVendorLoading,
  setDeparetmentLoading,
  setSetLoading,
  setLocationLoading,
  setCategoryLoading,
  setEpisodeLoading,
  setDepartmentSpendingData,
  setDepartmentSpendingGraph,
  setGraphAllData,
  setFinanceWorksheet,
  setFinanceWorksheetLoading,
  setFinanceWorksheetGroupBy,
  setFinanceWorksheetProductId,
  setFinanceWorksheetQuickSelect,
  setFinanceAddOnCharges,
  setFinanceAddOnChargesLoading,
  setFinanceWorksheetItemNickName,
} = spendingSlice.actions;

export default spendingSlice.reducer;

export interface FetchSpendingsOptions {
  /** When true, refetch without toggling banner spendingLoading (filter apply / background refresh). */
  silent?: boolean;
}

export const fetchSpendings = (
  productionId?: string,
  studioId?: string,
  departmentId?: string,
  productionScheduleType?: string,
  filterType?: string,
  setId?: string,
  setScheduleType?: string,
  categoryId?: string,
  locationId?: string,
  episodeId?: string,
  options?: FetchSpendingsOptions,
) => {
  const { dispatch } = store;
  const silent = Boolean(options?.silent);

  // Construct query params using URLSearchParams
  const params = new URLSearchParams();

  if (studioId) params.append('studioId', studioId);
  if (productionId) params.append('productionId', productionId);
  if (departmentId) params.append('departmentId', departmentId);
  if (productionScheduleType)
    params.append('productionScheduleType', productionScheduleType);
  if (filterType) params.append('filterType', filterType);
  if (setId) params.append('setId', setId);
  if (setScheduleType) params.append('setScheduleType', setScheduleType);
  if (categoryId) params.append('categoryId', categoryId);
  if (locationId) params.append('locationId', locationId);
  if (episodeId) params.append('episodeId', episodeId);

  if (!silent) {
    dispatch(setLoading(true));
  }
  const apiendpoint = `${
    endPoints.spending.filterTotalDaily
  }?${params.toString()}`;

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setSpendingData(data.data));
        // cb(data.data)
      }

      if (!silent) {
        dispatch(setLoading(false));
      }
    },
    (_e: any) => {
      if (!silent) {
        dispatch(setLoading(false));
      }
    },
  );
};

export const getStudioSpendingGraph = (
  studioId: string,
  entityType: string,
  id?: string,
  range?: string,
) => {
  const { dispatch } = store;
  dispatch(setOverAllGraphLoadingLoading(true));

  setStudioSpendingGraph({});

  // Build the API endpoint with the query and studioId
  // let apiendpoint = endPoints.production.dashboardGraph(type, id, range)

  let apiendpoint = endPoints.dashBoard.spendingGraph;

  if (id === 'allProductions') {
    apiendpoint +=
      `?filterType=production&entityType=${entityType}&entityId=${studioId}` +
      `&timeRange=${range}`;
  } else {
    apiendpoint +=
      `?entityType=${entityType}` + `&entityId=${studioId}&timeRange=${range}`;
  }

  // if (productionId) {
  //   apiendpoint = apiendpoint + '&productionId=' + productionId
  // }

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setStudioSpendingGraph(data?.data));

        // cb(data.data)
      }

      // Stop loading indicator
      dispatch(setOverAllGraphLoadingLoading(false));
    },
    (_e: any) => {
      // Handle error, stop loading
      dispatch(setOverAllGraphLoadingLoading(false));
    },
  );
};

export const getstudioEntitySpending = (
  studioId?: string,
  filterType?: string,
  productionScheduleType?: string,
  departmentId?: string,
  setId?: string,
  setScheduleType?: string,
  categoryId?: string,
  productionId?: string,
  locationId?: string,
  episodeId?: string,
  vendorId?: string,
) => {
  const { dispatch } = store;
  dispatch(setEntitySpendingLoading(true));

  if (filterType === 'department') {
    dispatch(setDeparetmentLoading(true));
    dispatch(setSetLoading(true));
    dispatch(setLocationLoading(true));
    dispatch(setCategoryLoading(true));
    dispatch(setVendorLoading(true));
  }
  if (filterType === 'episode') {
    dispatch(setEpisodeLoading(true));
    dispatch(setDeparetmentLoading(true));
    dispatch(setSetLoading(true));
    dispatch(setLocationLoading(true));
    dispatch(setCategoryLoading(true));
    dispatch(setVendorLoading(true));
  }
  if (filterType === 'set') {
    dispatch(setSetLoading(true));
    dispatch(setLocationLoading(true));
    dispatch(setCategoryLoading(true));
    dispatch(setVendorLoading(true));
  }
  if (filterType === 'location') {
    dispatch(setLocationLoading(true));
    dispatch(setCategoryLoading(true));
    dispatch(setVendorLoading(true));
  }
  if (filterType === 'category') {
    dispatch(setCategoryLoading(true));
    dispatch(setVendorLoading(true));
  }
  if (filterType === 'vendor') {
    dispatch(setVendorLoading(true));
  }

  // Construct query params using URLSearchParams
  const params = new URLSearchParams();

  if (studioId) params.append('studioId', studioId);
  if (productionId) params.append('productionId', productionId);
  if (departmentId) params.append('departmentId', departmentId);
  if (productionScheduleType)
    params.append('productionScheduleType', productionScheduleType);
  if (filterType) params.append('filterType', filterType);
  if (setId) params.append('setId', setId);
  if (setScheduleType) params.append('setScheduleType', setScheduleType);
  if (categoryId) params.append('categoryId', categoryId);
  if (locationId) params.append('locationId', locationId);
  if (episodeId) params.append('episodeId', episodeId);
  if (vendorId) params.append('vendorId', vendorId);

  const apiendpoint = `${
    endPoints.spending.entitySpendings
  }?${params.toString()}`;

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        console.log(data?.data, 'episodeSpendings73487368437', filterType);
        switch (filterType) {
          case 'department':
            dispatch(setDepartmentSpendings(data.data));
            dispatch(setDeparetmentLoading(false));
            if (data?.data?.topTenSpendings?.length === 0) {
              dispatch(setVendorLoading(false));
              dispatch(setCategoryLoading(false));
              dispatch(setLocationLoading(false));
              dispatch(setSetLoading(false));
              // dispatch(setEpisodeSpendings(false));
            }
            break;
          case 'episode':
            dispatch(setEpisodeLoading(false));
            dispatch(setEpisodeSpendings(data.data));
            if (data?.data?.topTenSpendings?.length === 0) {
              dispatch(setVendorLoading(false));
              dispatch(setCategoryLoading(false));
              dispatch(setLocationLoading(false));
              dispatch(setSetLoading(false));
            }
            break;
          case 'set':
            dispatch(setSetSpendings(data.data));
            dispatch(setSetLoading(false));
            if (data?.data?.topTenSpendings?.length === 0) {
              dispatch(setVendorLoading(false));
              dispatch(setCategoryLoading(false));
              dispatch(setLocationLoading(false));
            }
            break;
          case 'location':
            dispatch(setLocationSpendings(data.data));
            dispatch(setLocationLoading(false));
            if (data?.data?.topTenSpendings?.length === 0) {
              dispatch(setCategoryLoading(false));
              dispatch(setVendorLoading(false));
            }
            break;
          case 'category':
            dispatch(setCategorySpendings(data.data));
            dispatch(setCategoryLoading(false));
            if (data?.data?.topTenSpendings?.length === 0) {
              dispatch(setVendorLoading(false));
            }
            break;
          case 'vendor':
            dispatch(setVendorSpendings(data.data));
            dispatch(setVendorLoading(false));
            break;
        }
      }

      dispatch(setEntitySpendingLoading(false));
    },
    (_e: any) => {
      if (filterType === 'department') {
        dispatch(setDeparetmentLoading(false));
        dispatch(setSetLoading(false));
        dispatch(setLoading(false));
        dispatch(setCategoryLoading(false));
        dispatch(setVendorLoading(false));
      }
      dispatch(setEntitySpendingLoading(false));
    },
  );
};

export const getSpendingOrder = (
  entityId: string,
  entityType: string,
  page: number,
  limit?: number,
  productionId?: string,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  let apiendpoint = `${endPoints.spending.spendingOrder}?pageNo=${page}&entityId=${entityId}`;

  if (entityType) {
    apiendpoint += `&entityType=${entityType}`;
  }

  if (limit) {
    apiendpoint += `&limit=${limit}`;
  }

  if (productionId) {
    apiendpoint += `&productionId=${productionId}`;
  }
  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        console.log(data, 'data1212');
        dispatch(setOrderSpendings(data?.data));

        // cb(data.data)
      }

      // Stop loading indicator
      dispatch(setCommonDataLoader(false));
    },
    (_e: any) => {
      // Handle error, stop loading
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const getListOfEntities = (
  studioId: string,
  filterType: string,
  page: number,
  limit?: number,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  let apiendpoint = `${endPoints.spending.entityList}?page=${page}&studioId=${studioId}`;

  if (filterType) {
    apiendpoint += `&filterType=${filterType}`;
  }

  if (limit) {
    apiendpoint += `&limit=${limit}`;
  }
  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        if (filterType === 'department') {
          dispatch(setDepartmentList(data?.data));
        } else if (filterType === 'set') {
          dispatch(setSetList(data?.data));
        } else if (filterType === 'location') {
          dispatch(setLocationList(data?.data));
        } else if (filterType === 'category') {
          dispatch(setCategoryList(data?.data));
        }
      }

      // Stop loading indicator
      dispatch(setCommonDataLoader(false));
    },
    (_e: any) => {
      // Handle error, stop loading
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const fetchDepartmentSpendings = (
  id: string,
  produtionId?: string,
  studioId?: string,
  productionScheduleType?: string,
) => {
  const { dispatch } = store;

  dispatch(setLoading(true));
  let apiendpoint = `${endPoints.spending.departmentSpendings}?departmentId=${id}`;

  if (produtionId) {
    apiendpoint += `&productionId=${produtionId}`;
  }
  if (studioId) {
    apiendpoint += `&studioId=${studioId}`;
  }
  if (productionScheduleType) {
    apiendpoint += `&productionScheduleType=${productionScheduleType}`;
  }

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setDepartmentSpendingData(data.data));
        // cb(data.data)
      }

      // Stop loading indicator
      dispatch(setLoading(false));
    },
    (_e: any) => {
      // Handle error, stop loading
      dispatch(setLoading(false));
    },
  );
};

export const getDepartmentSpendingGraph = (
  departmentId: string,
  range: string,
  studioId?: string,
  productionId?: string,
  productionScheduleType?: string,
  locationId?: string,
  setId?: string,
  episodeId?: string,
) => {
  const { dispatch } = store;
  dispatch(setOverAllGraphLoadingLoading(true));

  setDepartmentSpendingGraph({});

  // Build the API endpoint with the query and studioId
  // let apiendpoint = endPoints.production.dashboardGraph(type, id, range)

  let apiendpoint = `${endPoints.spending.departmentGraphSpendings}?departmentId=${departmentId}&timeRange=${range}`;

  if (studioId) {
    apiendpoint += `&studioId=${studioId}`;
  }

  if (productionId) {
    apiendpoint += `&productionId=${productionId}`;
  }

  if (episodeId) {
    apiendpoint += `&episodeId=${episodeId}`;
  }

  if (locationId) {
    apiendpoint += `&locationId=${locationId}`;
  }
  if (setId) {
    apiendpoint += `&setId=${setId}`;
  }
  if (productionScheduleType) {
    apiendpoint += `&productionScheduleType=${productionScheduleType}`;
  }

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setDepartmentSpendingGraph(data?.data));

        // cb(data.data)
      }

      // Stop loading indicator
      dispatch(setOverAllGraphLoadingLoading(false));
    },
    (_e: any) => {
      // Handle error, stop loading
      dispatch(setOverAllGraphLoadingLoading(false));
    },
  );
};

export const fetchGraphSpendingsWithFilter = (
  range?: string,
  productionId?: string,
  studioId?: string,
  departmentId?: string,
  productionScheduleType?: string,
  filterType?: string,
  setId?: string,
  setScheduleType?: string,
  categoryId?: string,
  locationId?: string,
  episodeId?: string,
  options?: FetchSpendingsOptions,
) => {
  const { dispatch } = store;
  const silent = Boolean(options?.silent);

  // Construct query params using URLSearchParams
  const params = new URLSearchParams();
  if (range) params.append('timeRange', range);
  if (studioId) params.append('studioId', studioId);
  if (productionId) params.append('productionId', productionId);
  if (departmentId) params.append('departmentId', departmentId);
  if (productionScheduleType)
    params.append('productionScheduleType', productionScheduleType);
  if (filterType) params.append('filterType', filterType);
  if (setId) params.append('setId', setId);
  if (setScheduleType) params.append('setScheduleType', setScheduleType);
  if (categoryId) params.append('categoryId', categoryId);
  if (locationId) params.append('locationId', locationId);
  if (episodeId) params.append('episodeId', episodeId);

  if (!silent) {
    dispatch(setLoading(true));
  }
  const apiendpoint = `${
    endPoints.spending.filterGraphAll
  }?${params.toString()}`;

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setGraphAllData(data.data));
        // cb(data.data)
      }

      if (!silent) {
        dispatch(setLoading(false));
      }
    },
    (_e: any) => {
      if (!silent) {
        dispatch(setLoading(false));
      }
    },
  );
};

export interface FinanceWorksheetFilters {
  episodeId?: string;
  locationId?: string;
  setId?: string;
  productionId?: string;
  departmentId?: string;
  productionScheduleType?: string;
  setScheduleType?: string;
  // Disambiguates which nicknamed line item to filter by when multiple
  // order items share the same productId (see FinanceServiceWorksheet's
  // "Filter by Service" dropdown).
  itemNickName?: string;
}

export const fetchFinanceWorksheet = (
  tabType: string,
  groupBy: string,
  productId: string,
  quickSelect: string,
  fromDate: number | undefined,
  toDate: number | undefined,
  entityType?: string,
  entityId?: string,
  filters?: FinanceWorksheetFilters,
) => {
  const { dispatch } = store;
  dispatch(setFinanceWorksheetLoading(true));
  let url = `${endPoints.spending.financeWorksheetV2}?tabType=${tabType}`;

  if (entityId) url += `&entityId=${entityId}`;
  if (entityType) url += `&entityType=${entityType}`;
  if (fromDate) url += `&fromDate=${fromDate}`;
  if (toDate) url += `&toDate=${toDate}`;
  if (groupBy) url += `&groupBy=${groupBy}`;
  if (quickSelect) url += `&quickSelect=${quickSelect}`;
  if (productId) url += `&productId=${productId}`;
  if (filters?.itemNickName)
    url += `&itemNickName=${encodeURIComponent(filters.itemNickName)}`;
  if (filters?.episodeId && filters.episodeId !== entityId)
    url += `&episodeId=${filters.episodeId}`;
  if (filters?.locationId && filters.locationId !== entityId)
    url += `&locationId=${filters.locationId}`;
  if (filters?.setId && filters.setId !== entityId)
    url += `&setId=${filters.setId}`;
  if (filters?.productionId && filters.productionId !== entityId)
    url += `&productionId=${filters.productionId}`;
  if (filters?.departmentId) url += `&departmentId=${filters.departmentId}`;
  if (filters?.productionScheduleType) {
    url += `&productionScheduleType=${filters.productionScheduleType}`;
  }
  if (filters?.setScheduleType) {
    url += `&setScheduleType=${filters.setScheduleType}`;
  }

  getApiCall(
    url,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setFinanceWorksheet(data.data));
      }
      dispatch(setFinanceWorksheetLoading(false));
    },
    (_e: any) => {
      dispatch(setFinanceWorksheetLoading(false));
    },
  );
};

// Response shape: { statusCode, type, data: [{ note, noteFor, name,
// createdAt, ... }], message } — data is the notes array directly, matching
// ViewNotesModal's expected note shape.
export const fetchFinanceWorksheetShiftNotes = (
  shiftId: string,
  callback: (notes: any[]) => void,
) => {
  getApiCall(
    `${endPoints.spending.financeWorksheetShiftNotes}?shiftId=${shiftId}`,
    (s: any) => {
      const notes = s?.data?.data;
      callback(Array.isArray(notes) ? notes : []);
    },
    () => {
      callback([]);
    },
  );
};

// Same response shape as worksheet-shift-notes — data is the notes array
// directly, matching ViewNotesModal's expected note shape.
export const fetchFinanceWorksheetOrderNotes = (
  orderId: string,
  callback: (notes: any[]) => void,
) => {
  getApiCall(
    `${endPoints.spending.financeWorksheetOrderNotes}?orderId=${orderId}`,
    (s: any) => {
      const notes = s?.data?.data;
      callback(Array.isArray(notes) ? notes : []);
    },
    () => {
      callback([]);
    },
  );
};

// Response is one row per order item — { _id (order item id), productId,
// productName, itemNickName } — so the same service can repeat with
// different `_id`s. Dedup by productId is left to the caller since it's
// presentation logic, not part of the network call.
export const fetchFinanceWorksheetOrderProducts = (
  entityId: string,
  entityType: string | undefined,
  callback: (
    products: {
      _id: string;
      productId: string;
      productName: string;
      itemNickName?: string;
    }[],
  ) => void,
) => {
  getApiCall(
    `${endPoints.spending.financeWorksheetOrderProducts}?entityId=${entityId}&entityType=${entityType}`,
    (s: any) => {
      const products = s?.data?.data;
      callback(Array.isArray(products) ? products : []);
    },
    () => {
      callback([]);
    },
  );
};

export interface FinanceAddOnChargesFilters {
  fromDate?: number;
  toDate?: number;
  episodeId?: string;
  locationId?: string;
  setId?: string;
  productionId?: string;
  departmentId?: string;
  branchId?: string;
  productionScheduleType?: string;
  setScheduleType?: string;
}

// entityType must be one of: production, set, location, episode, studio.
export const fetchFinanceAddOnCharges = (
  entityType: string,
  entityId: string,
  filters?: FinanceAddOnChargesFilters,
) => {
  const { dispatch } = store;
  dispatch(setFinanceAddOnChargesLoading(true));

  const params = new URLSearchParams();
  params.append('entityType', entityType);
  params.append('entityId', entityId);
  if (filters?.fromDate) params.append('fromDate', String(filters.fromDate));
  if (filters?.toDate) params.append('toDate', String(filters.toDate));
  if (filters?.episodeId) params.append('episodeId', filters.episodeId);
  if (filters?.locationId) params.append('locationId', filters.locationId);
  if (filters?.setId) params.append('setId', filters.setId);
  if (filters?.productionId)
    params.append('productionId', filters.productionId);
  if (filters?.departmentId)
    params.append('departmentId', filters.departmentId);
  if (filters?.branchId) params.append('branchId', filters.branchId);
  if (filters?.productionScheduleType) {
    params.append('productionScheduleType', filters.productionScheduleType);
  }
  if (filters?.setScheduleType) {
    params.append('setScheduleType', filters.setScheduleType);
  }

  const apiendpoint = `${
    endPoints.spending.financeAddOnCharges
  }?${params.toString()}`;

  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setFinanceAddOnCharges(data.data));
      }
      dispatch(setFinanceAddOnChargesLoading(false));
    },
    (_e: any) => {
      dispatch(setFinanceAddOnChargesLoading(false));
    },
  );
};
